import { axiosClient } from '../../../library/Service/axiosClient';
import { REPORT_CONFIG } from '../../admin/reports/report-config';

class UploadUserService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};

        return Promise.all([
            this.getUserQueueStatus()
        ]).then((values) => {
            state.formConfig = {};
            state.data = {};
            state.routeInfo = params;
            state.internal = { gridState: {}, userQueueStatus: values[0]?.success };
            return Promise.resolve(state);
        });
    }

    static getUserQueueStatus = async() => {
        const response = await axiosClient().get(
            `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/raw-user/check-user-queue-status`
        );
        if (response.status === 200) {
            const data = response.data;
            return data
        }
    }
}
export default UploadUserService;
